import React  from 'react';
import {
  SiteContainer,
  Wrapper,
  Aside,
  Main,
} from 'core/layout';
import tulkojumi from 'utils/tulkojumi';
import { getDataFromACF } from 'utils/deepProps';
import { PaginationNav } from 'elements/Pagination';
import { BreadcrumbsConnected } from 'elements';
import {
  RezultatsItem,
  FilterSelect,
  NoderigiResursi,
  DateInput,
  KeywordsInput,
} from './components';
import {
  FlexGroup,
  StyledHeading,
  StyledList,
  ListHeading,
  StyledFilter,
  FilterLabel,
  DateRange,
  VisibleOnDesktop,
  VisibleOnTablet,
} from './styled';

class Rezultati extends React.PureComponent {
  _getFilterLabel = (slug, teksti, {allTerms} = {}) => {
    switch (slug) {
      case 'dokumenti_veidi':
        return allTerms ?
          tulkojumi(teksti, 'visi_dokumentu_veidi') :
          tulkojumi(teksti, 'dokumenta_veids');
      case 'dokumenti_departimenti':
        return allTerms ?
          tulkojumi(teksti, 'visi_departamenti') :
          tulkojumi(teksti, 'departaments');

      case 'iepirkumi_statuss':
        return allTerms ?
          tulkojumi(teksti, 'visi_iepirkumu_statusi') :
          tulkojumi(teksti, 'iepirkuma_statuss');
      case 'iepirkumi_liguma_veidi':
        return allTerms ?
          tulkojumi(teksti, 'visi_ligumu_veidi') :
          tulkojumi(teksti, 'liguma_veids');
      case 'iepirkumi_veidi':
        return allTerms ?
          tulkojumi(teksti, 'visi_iepirkumu_veidi') :
          tulkojumi(teksti, 'iepirkuma_veids');

      case 'nodoklu_zinojumi_dokumentu_veids':
        return allTerms ?
          tulkojumi(teksti, 'visi_nodoklu_zinojumi_dokumentu_veids') :
          tulkojumi(teksti, 'nodoklu_zinojumi');

      case 'projektu_joma':
        return allTerms ?
          tulkojumi(teksti, 'visas_projektu_jomas') :
          tulkojumi(teksti, 'projekta_joma');
      case 'projektu_statuss':
        return allTerms ?
          tulkojumi(teksti, 'visi_projektu_statusi') :
          tulkojumi(teksti, 'projekta_statuss');

      case 'dokumenti_tags':
      case 'projekti_tags':
      case 'post_tag':
        return allTerms ?
          tulkojumi(teksti, 'visas_temas') :
          tulkojumi(teksti, 'temas');

      default:
        return '';
    }
  }

  _onFilterDate = (id, date) => {
    const { filterByDate, filterState } = this.props;
    const newFilterState = Object.assign({}, filterState, {
      [id]: date,
    });
    filterByDate && filterByDate(newFilterState.from, newFilterState.to);
  }

  render() {
      const {
        postType,
        postsData,
        termsArray,
        page,
        teksti,
        lang,
        init_page,
        loadMoreEntries,
        filterByKeywords,
        filterByDate,
        filterState,
        filter,
        perpage,
        paginate,
        ...rest
      } = this.props;

      const noderigiResursiData = getDataFromACF(init_page, 'noderigi_resursi');
      const noderigiResursi = <NoderigiResursi resursi={noderigiResursiData} />

      const renderFilter = (slug) => {

        // NOTE: Input filtrs – satur vārdus
        if (slug === 'search') {
          return (
            <StyledFilter key={slug}>
              <FilterLabel>
                {tulkojumi(teksti, 'satur_vardus')}
              </FilterLabel>
                <KeywordsInput
                  teksti={teksti}
                  defaultValue={filterState[slug]}
                  placeholder={tulkojumi(teksti, 'satur_vardus')}
                  onChange={filterByKeywords}
                />
            </StyledFilter>
          );
        }

        // NOTE: Date filtrs – no / līdz
        if (slug === 'date') {
          return [
            <StyledFilter key='date-from'>
              <FilterLabel>
                {tulkojumi(teksti, 'publicets_no')}
              </FilterLabel>
              <DateRange>
                <DateInput
                  id='from'
                  teksti={teksti}
                  date={filterState.from}
                  placeholder={tulkojumi(teksti, 'piem')}
                  onChange={this._onFilterDate}
                />
              </DateRange>
            </StyledFilter>,

            <StyledFilter key='date-to'>
              <FilterLabel>
                {tulkojumi(teksti, 'publicets_lidz')}
              </FilterLabel>
              <DateRange>
                <DateInput
                  id='to'
                  teksti={teksti}
                  date={filterState.to}
                  placeholder={tulkojumi(teksti, 'piem')}
                  onChange={this._onFilterDate}
                />
              </DateRange>
            </StyledFilter>
          ];
        }

        const terms = postsData.terms[slug];
        const filteredData = filterState[slug];
        return terms && (
          <StyledFilter key={slug}>
            <FilterLabel>
              {this._getFilterLabel(slug, teksti)}
            </FilterLabel>
            <FilterSelect
              defaultOption={{
                id: slug,
                label: this._getFilterLabel(slug, teksti, { allTerms: true }),
                selected: !filteredData,
              }}
              options={terms && terms.map(term => ({
                id: term.slug,
                label: term.name,
                count: term.count,
                selected: filteredData && filteredData.indexOf(term.slug) > -1,
              }))}
              onChange={(id, selected) => {
                if (id === slug) {
                  filter(null, slug, null);
                } else {
                  filter(null, slug, id);
                }
              }}
            />
          </StyledFilter>
        );
      };

      const pagesTotal = Math.ceil(postsData.total / perpage);
      const allPosts = postsData.posts;

      const getPageButtonLabel = (currentPage) => (
        `${currentPage} ${tulkojumi(teksti, 'no')} ${pagesTotal}`
      );

      const prevPageButton = (filterState.page > 0) && {
        label: getPageButtonLabel(filterState.page),
        onClick: (event) => {
          event.preventDefault();
          paginate && paginate(filterState.page - 1)
        },
      };

      const nextPageButton = (filterState.page < pagesTotal - 1) && {
        label: getPageButtonLabel(filterState.page + 2),
        onClick: (event) => {
          event.preventDefault();
          paginate && paginate(filterState.page + 1)
        }
      };

      let filters = [...termsArray, 'search'];
      if (postType === 'jaunumi') {
        filters.push('date');
      }

      return (
        <SiteContainer>

          <BreadcrumbsConnected
            lang={lang}
            path={init_page.path}
          />

          <Wrapper>
            <StyledHeading>
                {init_page.title}
            </StyledHeading>

            <FlexGroup>
              <Aside>
                {filters && filters.map(renderFilter)}
                <VisibleOnDesktop>
                  {noderigiResursi}
                </VisibleOnDesktop>
              </Aside>

              <Main>

                <ListHeading>
                  <span>
                    {postsData.total}
                  </span>
                  &nbsp;
                  {tulkojumi(teksti, postType).toLowerCase()}
                </ListHeading>

                <StyledList>
                  {
                    allPosts && allPosts.map((post, index) => (
                      <RezultatsItem
                        key={index}
                        lang={lang}
                        teksti={teksti}
                        postType={postType}
                        termsArray={termsArray}
                        {...post}
                      />
                    ))
                  }
                </StyledList>

                <PaginationNav
                  prev={prevPageButton}
                  next={nextPageButton}
                  teksti={teksti}
                />

                <VisibleOnTablet>
                  {noderigiResursi}
                </VisibleOnTablet>

              </Main>
            </FlexGroup>
          </Wrapper>
        </SiteContainer>
    );
  }
}

export default Rezultati;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/Rezultati.jsx